import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CpMarketplaceApiService } from './cp-marketplace-api.service';

@Injectable({
  providedIn: 'root'
})
export class StateMachineActionsService {

  constructor(
    private cpApiSerive: CpMarketplaceApiService,
    private toastr: ToastrService
  ) { }

  /**
   * Handles movement of state machine based on the moveStateData.
   * @param issueId - ID of the Issue.
   * @param moveStateData - Data with which the state is moved.
   * @param message - Success Message to show user.
  */
  moveStateMachine(issueId: string, moveStateData: any, successMessage: string, callbackFn) {
    this.cpApiSerive.moveState(issueId, moveStateData).subscribe((moveStateResp) => {
      if (moveStateResp.status === 'success') {
        this.toastr.success(successMessage);

        if (callbackFn) {
          callbackFn(moveStateResp);
        }
      }
    });
  }
}
